import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { useLocation } from "react-router-dom";
import { logVisit } from "../utils/wkCommon";

export default function MasterLayoutGames({ title, children, rightAction }) {
  const history = useHistory();

  const location = useLocation();

  useEffect(() => {
    logVisit({
      path: location.pathname,
      query: location.search,
    });
  }, [location.pathname]);
  
  return (
    <div style={styles.wrapper}>
      <div style={styles.header}>
        <button
          className="btn-icon back-btn"
          onClick={() => history.push("/g/nav")}
          aria-label="Back"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
            <path fillRule="evenodd" d="M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z" clipRule="evenodd" />
          </svg>
        </button>

        <div style={styles.title}>{title}</div>
        <div>{rightAction}</div>
      </div>

      <div style={styles.content}>{children}</div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #fdfcfb, #e2d1c3)",
    padding: "1.5rem",
    boxSizing: "border-box",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1.5rem",
  },
  title: {
    fontSize: "1.6rem",
    fontWeight: "600",
  },
  content: {
    maxWidth: "40rem",
    margin: "0 auto",
  },
};